import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { IApplicationContext, ICustomContextParams } from '../../../shared/types/application';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    logger: getLogger(),
    httpApi: getHttpApi(),
    custom: config.getStrict<ICustomContextParams>('applicationContext.custom'),
    microfrontendsRegistry: registry(),
  };
};
